import axios from 'axios'
import errorParser from '@/utils/error-parser'

export default {
  /**
   * Fetch all organizations
   */
  getOrganizationData () {
    return new Promise((resolve, reject) => {
      axios.get('/organizations').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Add a new organization
   * @param {Object} organization detail
   */
  addOrganization (detail) {
    return new Promise((resolve, reject) => {
      axios.post('/organizations', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Update existing organization
   * @param {Integer} organization ID
   * @param {Object} organization detail
   */
  updateOrganization (organizationId, detail) {
    return new Promise((resolve, reject) => {
      axios.put('/organizations/' + organizationId, detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Delete an existing organization
   * @param {Integer} organization ID
   */
  deleteOrganization (organizationId) {
    return new Promise((resolve, reject) => {
      axios.delete('/organizations/' + organizationId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Fetch all facilities for a certain organization
   */
  getFacilityData (organizationId) {
    return new Promise((resolve, reject) => {
      axios.get('/facilities/' + organizationId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Add a new user facility
   * @param {Object} facility detail
   */
  addFacility (detail) {
    return new Promise((resolve, reject) => {
      axios.post('/facilities', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Update existing user facility
   * @param {Integer} facility ID
   * @param {Object} user facility detail
   */
  updateFacility (facilityId, detail) {
    return new Promise((resolve, reject) => {
      axios.put('/facilities/' + facilityId, detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Delete an existing facility
   * @param {Integer} facilityId
   */
  deleteFacility (facilityId) {
    return new Promise((resolve, reject) => {
      axios.delete('/facilities/' + facilityId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  getLatestCDCDataValues (organizationId) {
    return new Promise((resolve, reject) => {
      // '/latestdata/' '/mockdata/'
      axios.get('/organizations/latestdata/' + organizationId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  getDailyTotals (dateString, formatId) {
    return new Promise((resolve, reject) => {
      axios.get('/alltotalsfordayandformat/' + dateString + '/' + formatId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /*
  * MF try for collection values
  */
  getDailySensorTotals (dateString, formatId) {
    return new Promise((resolve, reject) => {
      axios.get('/dailysensortotals/' + dateString + '/' + formatId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  getSensorTotalForFacilityInScope (facilityId, firstDateString, lastDateString, reportType) {
    return new Promise((resolve, reject) => {
      axios.get('/sensortotalforfacilityinscope/' + facilityId + '/' + firstDateString + '/' + lastDateString + '?reportType=' + (reportType || 'daily')).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /*
  * Meter plan (Zählerübersicht): month-end readings per meter of a facility
  */
  getMeterPlanForFacility (facilityId, lastDateString, months, slack) {
    return new Promise((resolve, reject) => {
      const query = '?months=' + (months || 12) + (slack != null ? '&slack=' + slack : '')
      axios.get('/meterplanforfacility/' + facilityId + '/' + lastDateString + query).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  getSupplyContracts () {
    return new Promise((resolve, reject) => {
      axios.get('/supplycontracts').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  getOrganizationPlan (organizationId) {
    return new Promise((resolve, reject) => {
      axios.get('/organizations/' + organizationId + '/plan').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  createOrganizationPlan (organizationId, plan) {
    return new Promise((resolve, reject) => {
      axios.post('/organizations/' + organizationId + '/plan', plan).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  updateOrganizationPlan (organizationId, planId, plan) {
    return new Promise((resolve, reject) => {
      axios.put('/organizations/' + organizationId + '/plan/' + planId, plan).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  cancelOrganizationPlan (organizationId, planId) {
    return new Promise((resolve, reject) => {
      axios.delete('/organizations/' + organizationId + '/plan/' + planId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  addOrganizationPlanAddon (organizationId, planId, addon) {
    return new Promise((resolve, reject) => {
      axios.post('/organizations/' + organizationId + '/plan/' + planId + '/addon', addon).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  deleteOrganizationPlanAddon (organizationId, planId, addonId) {
    return new Promise((resolve, reject) => {
      axios.delete('/organizations/' + organizationId + '/plan/' + planId + '/addon/' + addonId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
